import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

export const fetchSortedProducts = createAsyncThunk(
  "sortedProducts/fetchSortedProducts",
  async (sortType) => {
    const response = await axios.get(`https://moga-dev.com/api/products/${sortType}`);
    let products = response.data.data;

    return products;
  }
);

const sortedProductsSlice = createSlice({
  name: "sortedProducts",
  initialState: {
    loading: false,
    products: [],
    error: null,
    currentPage: 0,
    itemsPerPage: 12,
    showAll: false,
    sortType: "recent-to-old",
  },
  reducers: {
    nextPage: (state) => {
      if (state.showAll) return;
      if ((state.currentPage + 1) * state.itemsPerPage >= state.products.length) {
        state.currentPage = 0;
      } else {
        state.currentPage += 1;
      }
    },
    prevPage: (state) => {
      if (state.showAll) return;
      if (state.currentPage === 0) {
        state.currentPage = Math.floor(state.products.length / state.itemsPerPage);
      } else {
        state.currentPage -= 1;
      }
    },
    goToPage: (state, action) => {
      if (state.showAll) return;
      state.currentPage = action.payload;
    },
    setSortType: (state, action) => {
      state.sortType = action.payload;
      state.currentPage = 0;
    },
    increaseItemsPerPage: (state) => {
      state.itemsPerPage += 12;
    },
    decreaseItemsPerPage: (state) => {
      if (state.itemsPerPage > 12) {
        state.itemsPerPage -= 12;
      }
    }, 
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSortedProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSortedProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchSortedProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { nextPage, prevPage, goToPage, setSortType, 
  increaseItemsPerPage, decreaseItemsPerPage ,
setItemsPerPage } = sortedProductsSlice.actions;
export default sortedProductsSlice.reducer;
